import { render, staticRenderFns } from "./BankDetailsTab.vue?vue&type=template&id=fee7790e&scoped=true&"
import script from "./BankDetailsTab.vue?vue&type=script&lang=js&"
export * from "./BankDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee7790e",
  null
  
)

export default component.exports